// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-document';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5.616 6.768a3.096 3.096 0 1 0 0-6.192 3.096 3.096 0 0 0 0 6.192zm.576 1.152c-.216 0-.36-.072-.576-.072a5.009 5.009 0 0 0-5.04 5.04m9-4.464h6.768c.648 0 1.152.504 1.152 1.152v6.768c0 .648-.504 1.152-1.152 1.152H9.576a1.137 1.137 0 0 1-1.152-1.152V9.576c0-.648.504-1.152 1.152-1.152zm1.08 2.232h4.536m-4.536 2.304h4.536m-4.536 2.232h1.728'
  />
);

export const viewBox = '0 0 18 18';
